import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

const LandingHero = ({ headline, subHeadline, ctaText }) => (

    <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block heroimg mb-5">
        <div className="col-12 col-md-7">
            <div className="col-12">
                <div className="text-white d-flex align-items-baseline justify-content-center justify-content-lg-start">
                    <svg
                        className="mr-2"
                        width="24"
                        height="19"
                        viewBox="0 0 24 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M22.1047 7.37815L21.4502 7.14015C21.3609 7.1104 21.2717 7.02115 21.2419 6.93189C21.0932 6.39638 20.9147 5.86087 20.7362 5.35511C20.6469 5.08736 20.4387 4.8791 20.1709 4.7601C19.9627 4.67085 19.7247 4.5816 19.5164 4.49234C19.0999 4.31384 18.8321 3.92708 18.8321 3.48082V1.10077C18.8321 0.50576 18.3264 0 17.7314 0C17.2256 0 16.7794 0.357007 16.6603 0.862768L16.3331 2.38005C16.2141 2.94531 15.6488 3.33207 15.0836 3.21307C13.001 2.88581 10.8887 2.85606 8.74668 3.21307C8.18142 3.30232 7.61616 2.94531 7.49716 2.38005L7.14015 0.862768C7.02115 0.357007 6.57489 0 6.06913 0C5.47411 0 4.96835 0.50576 4.96835 1.10077V3.48082C4.96835 3.92708 4.7006 4.34359 4.28409 4.49234C4.07584 4.5816 3.83783 4.67085 3.62958 4.7601C3.36182 4.8791 3.18332 5.08736 3.06431 5.35511C2.85606 5.86087 2.70731 6.39638 2.55855 6.93189C2.5288 7.02115 2.43955 7.1104 2.3503 7.14015L1.69579 7.3484C0.773516 7.64591 0 8.71693 0 9.6987V12.0788C0 13.0605 0.773516 14.1315 1.69579 14.4291L1.93379 14.5183C2.26105 14.6373 2.5288 14.9051 2.64781 15.2323C2.76681 15.6191 2.88581 16.0356 3.06431 16.4223C3.15357 16.6901 3.36182 16.8984 3.62958 17.0174C9.16319 19.4867 15.0538 19.3379 20.2007 17.0174C20.4684 16.8984 20.6469 16.6901 20.7659 16.4223C20.9147 16.0356 21.0634 15.6191 21.1824 15.2323C21.2717 14.8753 21.5395 14.6076 21.8965 14.5183L22.1642 14.4291C23.0865 14.1315 23.86 13.0605 23.86 12.0788V9.6987C23.8005 8.74668 23.027 7.67566 22.1047 7.37815ZM19.1892 14.9051C19.0999 15.2026 18.8619 15.4406 18.5644 15.5596C16.4223 16.4223 14.1613 16.8389 11.9002 16.8389C9.6392 16.8389 7.37815 16.3926 5.23611 15.5596C4.9386 15.4406 4.7006 15.2026 4.61135 14.9051C3.74858 12.287 3.74858 9.5202 4.61135 6.90214C4.7006 6.60464 4.9386 6.36663 5.23611 6.24763C7.40791 5.38486 9.6392 4.96835 11.9002 4.96835C14.191 4.96835 16.4223 5.41461 18.5644 6.24763C18.8619 6.36663 19.0999 6.60464 19.1892 6.90214C20.0519 9.5202 20.0519 12.287 19.1892 14.9051Z"
                        fill="white"
                        />
                        <path
                        d="M6.93164 8.68728V11.1566C6.93164 11.6921 7.3779 12.1383 7.91341 12.1383C8.44892 12.1383 8.89518 11.6921 8.89518 11.1566V8.68728C8.89518 8.15177 8.44892 7.70551 7.91341 7.70551C7.3779 7.67576 6.93164 8.12202 6.93164 8.68728Z"
                        fill="white"
                        />
                        <path
                        d="M14.875 8.68728V11.1566C14.875 11.6921 15.3213 12.1383 15.8568 12.1383C16.3923 12.1383 16.8385 11.6921 16.8385 11.1566V8.68728C16.8385 8.15177 16.3923 7.70551 15.8568 7.70551C15.3213 7.67576 14.875 8.12202 14.875 8.68728Z"
                        fill="white"
                        />
                        <path
                        d="M10.2052 13.3877H13.6265C13.7753 13.3877 13.8943 13.5067 13.8943 13.6555V14.5777C13.8943 14.7265 13.7753 14.8455 13.6265 14.8455H10.2052C10.0564 14.8455 9.93742 14.7265 9.93742 14.5777V13.6555C9.90767 13.5067 10.0564 13.3877 10.2052 13.3877Z"
                        fill="white"
                        />
                    </svg>

                    <span className="font-weight-normal" style={{ fontSize: '16px' }}>
                        AI Powered
                    </span>
                </div>
                <h1 className="font-weight-semibold hero-heading pt-0 no-br">
                    {headline}
                </h1>
                <p className="hero-para font-weight-semibold no-br" style={{ marginBottom: '20px' }}>
                    {subHeadline}
                </p>
                <div className="row" style={{ margin: '47px 0' }}>
                    <div className="col-12 col-md-6 px-md-0 d-flex align-items-center justify-content-start">
                    <StaticImage
                        src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1765949390/VantageFit/2025/webp-images/homepage/Group_1354_1"
                        alt="crowd review logo"
                        placeholder="none"
                        layout="constrained"
                        width={510}
                        height={83}
                        loading="eager"
                        imgStyle={{ objectFit: 'contain' }}
                    />
                    </div>
                </div>
                <div className="pl-0 pr-0 col-12 mtb25 d-md-flex justify-content-md-center d-lg-flex justify-content-lg-start align-items-center">
                    <a href="#bookDemo" className="vfitcompanycta mr-3 arrowbtn-img">
                        {ctaText}
                    </a>
                </div>
            </div>
        </div>
        <div className="col-12 col-md-5">
            <div className="right-img" style={{ maxWidth: '800px', margin: '0 auto' }}>
                <StaticImage
                src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1747819648/VantageFit/2025/Landing_page_hero-1"
                formats={['auto', 'webp']}
                alt="Vantage Fit image"
                placeholder="blurred"
                layout="constrained"
                width={516}
                height={441}
                transformOptions={{ quality: 80 }}
                loading="eager"
                fetchPriority="high"
                />
            </div>
        </div>
    </div>
    
)

export default LandingHero
